(function (ws) {
    'use strict';

    ws.views.splitOrderTableView = ws.views.tableModalView.extend({
        /**
         * Extend default events
         */
        events: _.extend({}, ws.views.tableModalView.prototype.events, {
            'click .qut-split-order-submit': 'callIncompletionLog',
            'click .qut-split-order-submit-merge-quote': 'submitMergeQuote',
            'click .qut-split-order-submit1': 'submit',
            'change .qut-split-order-checkbox': 'checkSelectedItems',
            'change #qut-split-order-select-all-checkbox': 'checkSelectedItems',
            'click .qut-split-order-cancel': 'close',
            'change #qut-split-order-textbox-quantity': 'updateQuantity',
            'keypress #qut-split-order-textbox-quantity': 'validateNumericInput'
        }),

        /**
         * Initialize
         */
        initialize: function () {
            ws.views.tableModalView.prototype.initialize.call(this);
            this.collection = new ws.collections.splitOrderCollection();
            this.$selectAllCheckbox = this.$('#qut-split-order-select-all-checkbox');
            this.showTableOnLoad = true;
            this.eventAgg.on('openSplitOrderModal', this.renderTable, this);
            this.eventAgg.on('triggerCheckboxCheck', this.checkSelectedItemsOverlay, this);
            this.$table = this.$('.qut-split-order-table');
            this.tableRowTemplate = $('#qut-split-order-row-template');
            if (!isOrderEntrySite) {
                this.incompletionErrorTemplate = _.template($('#qut-incompletion-overlay-template').html());
            }

            this.$tableContainer = $('.qut-split-order-table-wrapper');
            this.$submitButton = $('.qut-split-order-submit');
            this.emailModalId = $('.qut-split-order-email-modal').attr('id');
            this.$errorMessage = $('.split-order-errors');
            this.originalMessage = this.$errorMessage.text();
            this.$submitButton = this.$('.qut-split-order-submit');
        },

        /**
         * validate quote to order quantities taking in count the quantity restriction flag
         */
        validateQuantity: function() {
            var lineErrors = [];
            _.each(this.collection.getSelectedItems(), function(model) {
                if (model.isQtyInvalidOnRestricted()) {
                    lineErrors.push(model.get('id'));
                }
            });

            return lineErrors;
        },

        /**
         * formats error message and displays it
         * @param {Array} errors
         */
        showErrorMessage: function(errors) {
            var message = this.originalMessage;

            this.$errorMessage.text(function() {
                return message.replace('|lines|', errors.join(','));
            });

            this.$errorMessage.show().removeClass('hide');

            _.each(errors, function(lineNumber) {
                var qtyInput = this.$('.qut-split-qty[data-attr="' + lineNumber + '"]');
                qtyInput.addClass('qut-qty-error');
            }.bind(this));
        },

        /**
         * Check Items selected to enable/disable the submit button
         */
        checkSelectedItems: function(e) {
            e.preventDefault();
            this.$submitButton.prop('disabled', this.collection.getSelectedItems().length === 0);
        },

        /**
         * Check Items selected to enable/disable the submit button
         */
        checkSelectedItemsOverlay: function() {
            this.$submitButton.prop('disabled', this.collection.getSelectedItems().length === 0);
        },

        callIncompletionLog: function () {
            globals.disableApp();
            this.model = new ws.models.quoteSplitOrderIncompletionModel();
            this.model.set({
                products: this.collection.toAPI(),
                quoteId: $('.quoteID').val()
            });

            localStorage.setItem('products', JSON.stringify(this.collection.toAPI()));
            this.model.save().done(function (response) {
                globals.enableApp();
                if (response.showIncompletion) {
                    this.split = 'qut-openSplitOrderModal';
                    this.eventAgg.trigger(this.split + 'close');
                    var strGraphContent = this.incompletionErrorTemplate({incompletionErrorLog: response.incompletion});
                    $('.incompeletion-po-results').html('');
                    $('.incompeletion-po-results').html(strGraphContent);
                    if (response.splitOrderMsg) {
                        $('.split-order-error-message').html(response.splitOrderMsg);
                    }

                    this.eventAgg.trigger('submitIncompletionLogModal');
                    $('.submitToSap').removeClass('disabled');
                    $('.submitToSap').removeAttr('disabled');
                } else {
                    this.close();
                    globals.enableApp();
                    this.eventAgg.trigger('qut-openSplitOrderEmailModal');
                }
            }.bind(this)).fail(function () {
                globals.enableApp();
            }.bind(this));

        },

        /**
         * Close modal, prevent form submission
         * @param {Object} e
         */
        close: function(e) {
            this.onClose();
        },

        /**
         * updates the quantity on the split order table model
         */
        updateQuantity: function(e) {
            var qty = parseInt($(e.currentTarget).val());
            var id = $(e.currentTarget).data('attr');
            var model = this.collection.get(id);

            if (!isNaN(qty) && qty !== 0) {
                model.set('qtyToOrder', qty);
            } else {
                $(e.currentTarget).val(model.get('qtyToOrder'));
            }

        },

        /**
         * validates numeric input only in qty textbox
         */
        validateNumericInput: function(e) {
            if (e.which < 48 || e.which > 57)
            {
                e.preventDefault();
            }
        },

        /**
         * Override default updateButtons
         */
        updateButtons: function() {
            ws.views.tableModalView.prototype.updateButtons.call(this);
            this.$submitButton.attr('disabled', this.collection.getSelectedItems().length === 0);
        }

    });
})(westcon);
